// @flow
import { all } from "redux-saga/effects";

function* layoutSaga() {
  yield all([]);
}

export default layoutSaga;
